import { RepeatIcon, XCircleIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/business/visitor-parking/button'
import { HelpSection } from '@/components/business/visitor-parking/help-section'
import { Icon } from '@/components/ui/icon'
import { VisitorParkingFormLayout } from '@/pages/visitor-parking/visitor-parking-form-layout'

import * as S from './extend-parking-payment-error.styled'

interface ExtendParkingPaymentErrorProps {
  onRetryPayment: () => void
}

export const ExtendParkingPaymentError = ({ onRetryPayment }: ExtendParkingPaymentErrorProps) => {
  const { t } = useTranslation(['visitor-parking'])
  const handleRetryPayment = () => {
    onRetryPayment()
  }

  return (
    <VisitorParkingFormLayout
      footer={
        <Button onClick={handleRetryPayment}>
          {t('visitor-parking:extendParkingPaymentError.retry')} <Icon icon={RepeatIcon} />
        </Button>
      }
    >
      <S.Title>{t('visitor-parking:extendParkingPaymentError.title')}</S.Title>
      <S.Card>
        <S.Icon icon={XCircleIcon} size="8rem" weight="fill" />
        <S.ErrorInfo>{t('visitor-parking:extendParkingPaymentError.errorInfo')}</S.ErrorInfo>
        <S.ErrorDescription>
          {t('visitor-parking:extendParkingPaymentError.errorDescription')}
        </S.ErrorDescription>
      </S.Card>
      <HelpSection />
    </VisitorParkingFormLayout>
  )
}
